import { render, staticRenderFns } from "./TacticalKnowledge.vue?vue&type=template&id=15899635&"
import script from "./TacticalKnowledge.vue?vue&type=script&lang=ts&"
export * from "./TacticalKnowledge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports